<h5>Produktionsinfos:</h5>

<p-button (onClick)="load()" [label]="'common.reload' | translate" />

<br />

<!-- <ng-container *ngFor="let grouped of groups()"> -->
<!-- <accordion class="panel-wrapper-accordion" [isAnimated]="true">
        <accordion-group
            heading="{{grouped.lineItem.identifier}} {{grouped.lineItem.description}} ({{grouped.lineItem.quantity}})"
            [isOpen]="true">
            <ng-container *ngFor="let g of grouped.groups">
                <h5>
                    <i [pTooltip]="('enums.' + g.finishState) | translate" class="fa fa-circle"
                        style="margin-right: 5pt;" [ngClass]="'production-group-finishState-' + g.finishState"></i>

                    <b><a href="{{groupDoubleClickUrl}}{{g.id}}">{{g.identifier}}</a></b> {{g.description}}
                    ({{g.createdAt | date:'medium'}})
                </h5>
                <ng-container *ngIf="g.notes">
                    <label>Notizen</label>
                    <span>{{g.notes}}</span>
                </ng-container>

                <div style="text-align: right;">
                    <p-button severity="danger" (onClick)="resetGroup(g.id)">{{'common.reset' | translate}}</p-button>
                </div>
            </ng-container>
        </accordion-group>
    </accordion> -->
<!-- </ng-container> -->

<p-accordion [value]="0">
    <ng-container *ngFor="let grouped of groups(); let i = index">
        <p-accordion-panel [value]="i">
            <p-accordion-header>
                {{ grouped.lineItem.identifier }} {{ grouped.lineItem.description }} ({{
                    grouped.lineItem.quantity
                }})
            </p-accordion-header>
            <p-accordion-content>
                <ng-container *ngFor="let g of grouped.groups">
                    <h5>
                        <i
                            [pTooltip]="'enums.' + g.finishState | translate"
                            class="fa fa-circle"
                            style="margin-right: 5pt"
                            [ngClass]="'production-group-finishState-' + g.finishState"
                        ></i>

                        <b
                            ><a href="{{ groupDoubleClickUrl }}{{ g.id }}">{{ g.identifier }}</a></b
                        >
                        {{ g.description }} ({{ g.createdAt | date: 'medium' }})
                    </h5>
                    <ng-container *ngIf="g.notes">
                        <label>Notizen</label>
                        <span>{{ g.notes }}</span>
                    </ng-container>

                    <div style="text-align: right">
                        <p-button
                            severity="danger"
                            (onClick)="resetGroup(g.id)"
                            [label]="'common.reset' | translate"
                        />
                    </div>
                </ng-container>
            </p-accordion-content>
        </p-accordion-panel>
    </ng-container>
</p-accordion>
